import React, { PureComponent } from 'react';
import {
  Icon
} from 'antd';

const css = require('./error.scss');

interface IProps {
  message: string;
}

class MyState {
  visable: boolean = true;
}

export default class Error extends PureComponent<IProps, MyState> {
  constructor (props: IProps) {
    super(props);
    this.state = new MyState;
  }

  render () {
    const { message } = this.props;
    const { visable } = this.state;
    return (
      <>
        {
          visable && 
          <div className={css['error']}>
            <p><Icon type="close-circle" style={{ color: '#ec6b43', marginRight: '12px' }} />{message}</p>
            <Icon onClick={this.closeThis} type="close" style={{ color: '#99A9BF' }} />
          </div>
        }
      </>
    );
  }

  private closeThis = () => {
    this.setState({
      visable: false,
    });
  }

}


// WEBPACK FOOTER //
// ./src/display/platform/Document/InvoiceDetail/UI.Error.tsx